"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactAdminToUseApp = void 0;
var openLink_1 = __importDefault(require("dingtalk-jsapi/api/biz/util/openLink"));
/**
 * @name contactAdminToUseApp
 * @category biz Helpers
 * @summary 联系管理员，开通应用或授权当前用户使用应用
 * @description
 * 唤起联系管理员界面，让管理员开通应用或授权当前用户使用应用
 * 支持小程序和H5微应用
 *
 * @param {Object} opt - 联系管理员参数配置
 * @param {String} [opt.corpId] - 组织ID
 * @param {Number|String} [opt.id] - 应用ID或模板ID
 * @param {String} [opt.type] - 类型，标识应用或模板，可选参数。值为"APP"或"TEMPLATE"，默认为"APP"
 * @returns {Promise}
 * @example
 * // 唤起联系管理员界面
 * contactAdminToUseApp({ id: 1234, corpId: 'dingxxxxxxxx', })
 */
function contactAdminToUseApp(opt) {
    var id = opt.id, _a = opt.type, type = _a === void 0 ? 'APP' : _a, corpId = opt.corpId;
    if (!corpId || !id) {
        var ERR_MSG = 'contactAdmin error: id or corpId is missing, contactAdmin({ id: \'appId\', corpId: \'corpId\'})';
        console.error(ERR_MSG);
        return Promise.reject({
            error: 'params error',
            message: ERR_MSG,
        });
    }
    var path = "pages/contact-admin/index?corpId=" + corpId + "&appEntityId=" + id + "&appEntityType=" + type;
    var url = "dingtalk://dingtalkclient/action/open_mini_app?miniAppId=2021001101675384&page=" + encodeURIComponent(path);
    return openLink_1.default({ url: url, });
}
exports.contactAdminToUseApp = contactAdminToUseApp;



//////////////////
// WEBPACK FOOTER
// ./node_modules/dingtalk-design-libs/biz/contactAdminToUseApp/index.js
// module id = Wwam
// module chunks = 0